export enum AccountUsage {
	TEST = 'test',
	PROD = 'prod'
}
export enum AccountCategory {
	ENERGY_PROVIDER = 'ENERGY_PROVIDER',
	FACILITY_MANAGEMENT = 'FACILITY_MANAGEMENT',
	INSURANCE_AGENT = 'INSURANCE_AGENT',
	CRAFTSMEN = 'CRAFTSMEN',
	MEASUREMENT_SERVICE = 'MEASUREMENT_SERVICE',
	OTHER_SERVICE_PROVIDER = 'OTHER_SERVICE_PROVIDER',
	INSURANCE_INTEGRATION = 'INSURANCE_INTEGRATION',
	TEST = 'TEST'
}
